// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b62d949c","453":"18f5f30d","455":"caf03277","977":"a83bfe91"}[chunkId] + ".chunk.js";
};